import React, { useCallback } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text/Text';
import Divider from 'fe-design-base/molecules/Divider/Divider';
import Link from 'fe-design-base/molecules/Link/Link';

import { sendEmailOtp } from 'features/authentication/actions';
import CodeForm from 'features/authentication/SignIn/CodeForm';
import { ForgotPasswordStep } from 'features/authentication/SignIn/constants';
import { ErrorTrackingProps } from 'features/authentication/SignIn/types';

import { toI18n } from 'util/i18n';

type Props = {
  email: string;
  emailId: string;
  onSetEmailId: (id: string) => void;
  onSetStep: (view: ForgotPasswordStep) => void;
  onSuccess: () => void;
} & ErrorTrackingProps;
const EmailCodeForm = ({
  email,
  emailId,
  onSetStep,
  onSetEmailId,
  onError,
  onSuccess,
}: Props) => {
  const handleSuccess = useCallback(() => {
    onSetStep(ForgotPasswordStep.PASSWORD);
    onSuccess();
  }, [onSetStep, onSuccess]);

  const handleSetEmailView = useCallback(() => {
    onSetStep(ForgotPasswordStep.EMAIL);
  }, [onSetStep]);

  const handleEmailResend = useCallback(() => sendEmailOtp({ email }), [email]);

  const bottomContent = (
    <>
      <Divider type="light" color="mono400" spacing={32} />
      <Box column gap={16}>
        <Text
          variant="heading4"
          i18n="authentication.code.bottom_content.title"
        />
        <Text i18n="authentication.code.bottom_content.ask_manager" />
        <Text i18n="authentication.code.bottom_content.have_account">
          &nbsp;
          <Link onClick={handleSetEmailView} uxElement="different email link">
            {toI18n('authentication.code.bottom_content.email_link')}
          </Link>
          .
        </Text>
      </Box>
    </>
  );

  return (
    <CodeForm
      email={email}
      methodId={emailId}
      onSetMethodId={onSetEmailId}
      onSuccess={handleSuccess}
      onResendCode={handleEmailResend}
      onError={onError}
      bottomContent={bottomContent}
    />
  );
};

export default EmailCodeForm;
